import React from "react"
import { Link } from "gatsby"
import styles from "./arrayBooks.module.scss"
///import Image from "gatsby-image"

const ArrayBooks = ({ className, books }) => {
  if(books) {
    return (
      <div className={`${className} ${styles.container}`}>
        {books.map(({ node }, index) => (
          <Link key={index.toString()} to={node.slug} className="flex justify-center items-center mb-5 flex justify-center" >
            <img src={node.image.childImageSharp.fixed.src} alt={node.title}/>
          </Link>
        ))}
      </div>
    )
  } else {
    return (
      <p>Aucun livre pour le moment</p>
    )
  }
}

export default ArrayBooks